module.exports = __webpack_public_path__ + "static/exterior2-a1a11692c41edc79c6ba58dddabbde28.jpg";